var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { class: ["iconfont-v4", _vm.iconName, _vm.className] })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }